import Vue from "vue";

// @ts-ignore
import FlagIcon from "vue-flag-icon";

Vue.use(FlagIcon);
